var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.681,
    height: 48.813,
    viewBox: "0 0 39.681 48.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medal",
    transform: "translate(-45.799 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M294.368,321.353l-5.877-1.293-1.821,5.75a.5.5,0,0,1-.907.1l-7.27-12.629a18.051,18.051,0,0,0,9.214-5.171l7.2,12.509A.5.5,0,0,1,294.368,321.353Z",
    transform: "translate(-209.495 -277.391)",
    fill: "#fd646f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M294.369,321.352l-5.432-1.2a.5.5,0,0,0-.582.336l-1.684,5.316a.5.5,0,0,1-.907.1l-6.228-10.82-1.042-1.809a18.051,18.051,0,0,0,9.214-5.171l1.034,1.795,6.167,10.715a.5.5,0,0,1-.539.736Z",
    transform: "translate(-209.496 -277.39)",
    fill: "#fd646f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M383.422,413.67l-5.431-1.2a.5.5,0,0,0-.582.336l.585-1.817a.5.5,0,0,1,.583-.334l4.674,1.039.712,1.236A.5.5,0,0,1,383.422,413.67Z",
    transform: "translate(-298.549 -369.709)",
    fill: "#fc4755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M62.4,318.752l-7.385,12.826a.5.5,0,0,1-.907-.1l-1.684-5.316a.5.5,0,0,0-.582-.336l-5.432,1.2a.5.5,0,0,1-.539-.735l6.868-11.933A18.171,18.171,0,0,0,62.4,318.752Z",
    transform: "translate(0 -283.016)",
    fill: "#fd646f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(45.8 30.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M53.709,307.292l-6.12,10.633-1.181.26a.5.5,0,0,1-.539-.735l5.846-10.157,1.581-2.754q.639.6,1.334,1.146Z",
    transform: "translate(-45.801 -304.538)",
    fill: "#fc4755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M110.262,430.122l-.721,1.252a.5.5,0,0,1-.907-.1l-1.684-5.316a.5.5,0,0,0-.582-.337l1.862-.41a.5.5,0,0,1,.582.336Z",
    transform: "translate(-100.33 -413.173)",
    fill: "#fc4755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M106.311,311.311l4.857,2.19,4.638,2.51-1.244,2.158a19.965,19.965,0,0,1-9.343-4.695l-.1-.085Z",
    transform: "translate(-99.209 -310.636)",
    fill: "#fc4755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M288.741,309.9l-1.034-1.795-5.471,2.415-3.743,2.756.421.73,1.033,1.794,5.816,10.1a.5.5,0,0,0,.907-.1l.37-1.169-5.781-10.069A19.956,19.956,0,0,0,288.741,309.9Z",
    transform: "translate(-255.295 -307.752)",
    fill: "#fc4755"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M99.505,18.148A18.077,18.077,0,0,1,69.386,31.707c-.136-.12-.268-.242-.4-.367a18.5,18.5,0,0,1-1.328-1.4A18.129,18.129,0,0,1,86.666.778a18.056,18.056,0,0,1,6.5,3.577,18.14,18.14,0,0,1,6.337,13.793Z",
    transform: "translate(-15.772)",
    fill: "#faa515"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 12.96,
    cy: 12.999,
    rx: 12.96,
    ry: 12.999,
    transform: "translate(52.68 5.149)",
    fill: "#fad207"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M140.737,167.59a12.959,12.959,0,1,1-25.821-1.6,12.956,12.956,0,0,0,25.723,0A13.032,13.032,0,0,1,140.737,167.59Z",
    transform: "translate(-62.138 -149.442)",
    fill: "#faa515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M127.777,51.656a13,13,0,1,0,12.959,13A12.979,12.979,0,0,0,127.777,51.656Zm0,24.5a11.5,11.5,0,1,1,11.464-11.5A11.494,11.494,0,0,1,127.777,76.153Z",
    transform: "translate(-62.138 -46.506)",
    fill: "#faf063",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M181.736,107.414l1.78,3.637a.5.5,0,0,0,.377.274l4,.575a.5.5,0,0,1,.277.85l-2.9,2.826a.5.5,0,0,0-.143.442l.691,4a.5.5,0,0,1-.725.525l-3.571-1.892a.5.5,0,0,0-.467,0l-3.571,1.892a.5.5,0,0,1-.725-.525l.691-4a.5.5,0,0,0-.143-.442l-2.9-2.826a.5.5,0,0,1,.277-.85l4-.575a.5.5,0,0,0,.377-.274l1.78-3.637A.5.5,0,0,1,181.736,107.414Z",
    transform: "translate(-115.649 -96.454)",
    fill: "#faa515"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.5b1cda279f43789ed7d9f957a3d27aab.svg";
export { ForwardRef as ReactComponent };